import { useEffect, useRef } from "react";
interface OutsideClickHandlerProps {
  onOutsideClick:any;
  children:any;
  className?: string;
}
const OutsideClickHandler = ({
  onOutsideClick,
  children,
  className,
}: OutsideClickHandlerProps) => {
  const wrapperRef = useRef<any>(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  return <div ref={wrapperRef} className={className}>{children}</div>;
};

export default OutsideClickHandler;
